export function transformFilename(filename) {
  // 拆 query string
  const [main, query] = filename.split("?");
  
  // 找最後一個點的位置
  const lastDotIndex = main.lastIndexOf(".");
  let name = main.substring(0, lastDotIndex);   // 檔名主體
  let ext = main.substring(lastDotIndex + 1).toLowerCase(); // 副檔名

  // 如果是 jpeg，改成 jpg
  if (ext === "jpeg") {
    ext = "jpg";
  }

  // 組合新的檔名
  const newMain = `${name}-large.${ext}`;

  // 加回 query string
  return query ? `${newMain}?${query}` : newMain;
}



